import { mediaDataProps } from '../lib/mediaTruth';
import PhotoSlot from './PhotoSlots';

const MediaTruthSurface = ({ media, className = '' }) => (
  <PhotoSlot {...mediaDataProps(media)} id={media.id} label={`${media.label} photo`} className={className} />
);

export default MediaTruthSurface;
